import { toast } from '@/common/util'
import BaseService from './base.service'
import type { SubscriptionsBatchType } from '@/types/types'

class InscricoesService extends BaseService {
  constructor() {
    super({ resource: 'inscricao' })
  }

  async validateFile(file: File): Promise<{ success: boolean; data: SubscriptionsBatchType }> {
    const formData = new FormData()
    formData.append('file', file)

    return await this.plantarApi.post(`${this.resource}/validatebatch/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  }

  async importSubscriptions(fileId: string): Promise<{ success: boolean; data: SubscriptionsBatchType }> {
    try {
      return await this.plantarApi.post(`${this.resource}/importbatch/${fileId}`)
    } catch (error) {
      const { notifications }: { notifications: string[] } = error.response?.data || {}
      toast.error({ message: notifications[0] || 'Erro ao tentar importar dados!' })
    }
  }
}

const inscricoesService = new InscricoesService()

export default inscricoesService
